import { a as e, i as t } from "./article-list.service-DgVg00eV.js";
import { ROUTES as n, SEARCH_DEBOUNCE as r } from "@editor/ui-utils";
import { QSelect as i } from "quasar";
import { computed as a, createBlock as o, defineComponent as s, mergeModels as c, mergeProps as l, openBlock as u, ref as d, unref as f, useModel as p, watch as m } from "vue";
import { queryOptions as h, useQuery as g, useQueryClient as _ } from "@tanstack/vue-query";
import { useI18n as v } from "vue-i18n";
//#endregion
//#region src/lang/index.ts
var y = {
	en: {
		articleListApi: {
			createAlreadyExists: "Article list cannot be created because another article list with this name already exists",
			updateAlreadyExists: "The article list cannot be updated because another article list with this name already exists.",
			created: "Article list created",
			updated: "Article list updated",
			notFound: "Article list not found",
			requiredFields: "The article list cannot be saved because mandatory information is missing.",
			referencedByChannel: "The article list is still being referenced in some channels."
		},
		articleListList: {
			newButton: "New article list",
			name: "Search for list title (internal)",
			dpAny: "All",
			brand: "Brand",
			loading: "Loading article list",
			headerLabel: "List title (internal)",
			headerCreatedAt: "Creation date",
			headerChangedAt: "Last modified date",
			counter: "Counter",
			dpEdit: "Edit",
			dpView: "View",
			errorOnDeleting: "Error deleting"
		},
		articleList: {
			articleListLabel: "Article list",
			deleteArticleList: "Delete",
			messageDeleted: "Article list deleted",
			messageDeleteArticleList: "Are you sure you want to delete this article list?",
			messageDeleteArticleListTitle: "Delete article list",
			errorOnDeleting: "Error deleting the article list",
			errorFailedLoadedArticleListWithId: "Error getting the article list",
			handledInLegacySystem: "This article list is being handled in {source}, it is not editable in Vibe."
		},
		articleListEdit: {
			title: "List content",
			placeholder: "Place article here ",
			placeholderFirst: "Place first article here",
			selectArticle: "Select article",
			selectLinkoutTeaser: "Select linkout teaser",
			loading: "Loading",
			saveAndPublish: "Save & publish",
			revertChanges: "Discard changes",
			previouslySelectedMessage: "Previously selected for the article list",
			label: "List title (internal)",
			showAlternativeTeaserTitle: "Show alternative teaser",
			showAlternativeTeaserTitleTooltip: "Shows alternative kicker and main headline for teasers in the list, if set for an article.",
			counter: "Counter",
			editArticleList: "Edit article list",
			searchByTitleOrKicker: "Search for kicker or main title",
			messageSaved: "New article list saved",
			errorWrongBrand: "All articles in the list have to belong to the same brand.",
			errorWrongState: "All articles in the list must be published, draft, or scheduled.",
			errorNoArticles: "A minimum of one valid article is required in the article list.",
			errorDontChangeBrand: "The article list's brand cannot be changed.",
			canNotCreateNewList: "You do not have permission to create a new article list.",
			revertChangesConfirmationDialogTitle: "There are unpublished changes.",
			revertChangesConfirmationDialogMessage: "Are you sure you want to discard all changes made to the list?",
			revertChangesConfirmationDialogOk: "Yes, discard changes",
			revertChangesConfirmationDialogCancel: "No, keep changes",
			removeArticleFromPreviouslyUsedArticlesTitle: "Remove  article from used articles",
			removeArticleFromPreviouslyUsedArticlesMessage: "Are you sure you want to remove this article from the previously used articles in the list?",
			scheduleArticle: "Schedule article",
			scheduleButton: "Schedule",
			unscheduleButton: "Unschedule",
			scheduleVisibilityHintInList: "The article always remains in this list.",
			scheduleVisibilityHintTiming: "Scheduling only limits when it is rendered on the channel (from the start time, until the end time, or both).",
			alreadyScheduledFromTo: "This article is already scheduled to be rendered in the list from {fromDate} to {toDate}.",
			alreadyScheduledFrom: "This article is already scheduled from {fromDate}",
			alreadyScheduledTo: "This article is already scheduled in the list to {toDate}.",
			fromDateSelector: "Start date and time",
			toDateSelector: "End date and time",
			timed: "Timed",
			scheduleActive: "Active",
			scheduleExpired: "Expired",
			draft: "Draft",
			scheduled: "Scheduled",
			allArticles: "All articles",
			published: "Published",
			scheduledSlotFromOnly: "From {date}",
			scheduledSlotUntilOnly: "Until {date}",
			scheduledChipAriaUpcoming: "Upcoming schedule: {dates}",
			scheduledChipAriaActive: "Active schedule: {dates}",
			scheduledChipAriaExpired: "Expired schedule: {dates}",
			invalidScheduleDate: "The start date must be before the end date.",
			refreshList: "Refresh list",
			lastRefresh: "Last refresh",
			lowData: "Low data",
			abTestRunning: "A/B headline test running",
			ctrUnavailable: "CTR unavailable",
			ctrUnavailableHint: "Live CTR data could not be loaded right now. It will refresh automatically."
		}
	},
	de: {
		articleListApi: {
			createAlreadyExists: "Artikel-Liste kann nicht erstellt werden, weil bereits eine Artikel-Liste mit diesem Namen existiert.",
			updateAlreadyExists: "Die Artikel-Liste kann nicht aktualisiert werden, weil bereits eine Artikel-Liste mit diesem Namen existiert.",
			created: "Artikel-Liste erstellt",
			updated: "Artikel-Liste aktualisiert",
			notFound: "Artikel-Liste nicht gefunden",
			requiredFields: "Die Artikel-Liste kann nicht gespeichert werden, weil Pflichtinformationen fehlen.",
			referencedByChannel: "Die Artikel-Liste wird noch in einigen Channels referenziert."
		},
		articleListList: {
			newButton: "Neue Artikel-Liste",
			name: "Suchen nach Titel (intern) der Artikel-Liste",
			dpAny: "Alle",
			brand: "Marke",
			loading: "Artikel-Liste wird geladen",
			headerLabel: "Listen-Titel (intern)",
			headerCreatedAt: "Erstellungdatum",
			headerChangedAt: "Änderungsdatum (last modified)",
			counter: "Zähler",
			dpEdit: "Bearbeiten",
			dpView: "Anzeigen",
			errorOnDeleting: "Fehler beim Löschen"
		},
		articleList: {
			articleListLabel: "Artikel-Liste",
			deleteArticleList: "Löschen",
			messageDeleted: "Artikel-Liste gelöscht",
			messageDeleteArticleList: "Willst du diese Artikel-Liste wirklich löschen?",
			messageDeleteArticleListTitle: "Artikel-Liste löschen",
			errorOnDeleting: "Fehler beim Löschen der Artikel-Liste",
			errorFailedLoadedArticleListWithId: "Fehler beim Abrufen der Artikel-Liste",
			handledInLegacySystem: "Diese Artikel-Liste wird in {source} verwaltet. Sie kann nicht in Vibe bearbeitet werden."
		},
		articleListEdit: {
			title: "Inhalt auflisten",
			placeholder: "Artikel hier einfügen",
			placeholderFirst: "Ersten Artikel hier platzieren",
			selectArticle: "Artikel auswählen",
			selectLinkoutTeaser: "Linkout-Teaser auswählen",
			loading: "Laden",
			label: "Listen-Titel (intern)",
			showAlternativeTeaserTitle: "Alternativen Teaser anzeigen",
			showAlternativeTeaserTitleTooltip: "Zeigt alternative Vor- und Hauptzeile für Teaser in der Liste an, sofern für einen Artikel gesetzt.",
			previouslySelectedMessage: "Zuvor für die Artikel-Liste ausgewählt",
			saveAndPublish: "Speichern & veröffentlichen",
			revertChanges: "Änderungen verwerfen",
			counter: "Zähler",
			searchByTitleOrKicker: "Suchen nach Vorzeile oder Hauptzeile",
			editArticleList: "Artikel-Liste bearbeiten",
			messageSaved: "Neue Artikel-Liste gespeichert",
			errorWrongBrand: "Alle Artikel in der Artikel-Liste müssen zur selben Marke gehören.",
			errorWrongState: "Alle Artikel in der Liste müssen veröffentlicht, Entwurf oder geplant sein.",
			errorNoArticles: "Die Artikel-Liste muss mindestens einen gültigen Artikel enthalten.",
			errorDontChangeBrand: "Die Marke der Artikel-Liste kann nicht geändert werden.",
			canNotCreateNewList: "Dir fehlt die Berechtigung zum Erstellen einer neuen Artikel-Liste.",
			revertChangesConfirmationDialogTitle: "Es gibt unveröffentlichte Änderungen.",
			revertChangesConfirmationDialogMessage: "Willst du wirklich alle Änderungen an der Artikel-Liste verwerfen?",
			revertChangesConfirmationDialogOk: "Ja, Änderungen verwerfen",
			revertChangesConfirmationDialogCancel: "Nein, Änderungen behalten",
			removeArticleFromPreviouslyUsedArticlesTitle: "Artikel aus den verwendeten Artikeln entfernen",
			removeArticleFromPreviouslyUsedArticlesMessage: "Willst du diesen Artikel wirklich aus den zuvor verwendeten Artikeln in dieser Liste entfernen?",
			scheduleArticle: "Artikel planen",
			scheduleButton: "Planen",
			unscheduleButton: "Planung aufheben",
			scheduleVisibilityHintInList: "Der Artikel bleibt immer in dieser Liste.",
			scheduleVisibilityHintTiming: "Die Planung begrenzt nur, wann er auf dem Kanal ausgespielt wird (ab Startzeit, bis Endzeit oder beides).",
			alreadyScheduledFromTo: "Dieser Artikel ist bereits geplant und wird von {fromDate} bis {toDate} über die Liste ausgespielt.",
			alreadyScheduledFrom: "Das Teasering des Artikels ist bereits ab {fromDate} geplant.",
			alreadyScheduledTo: "Dieser Artikel ist in der Liste bereits bis {toDate} geplant.",
			fromDateSelector: "Starttag und -zeit",
			toDateSelector: "Endtag und -zeit",
			timed: "Geplant",
			scheduleActive: "Aktiv",
			scheduleExpired: "Abgelaufen",
			draft: "Entwurf",
			scheduled: "Geplant",
			allArticles: "Alle Artikel",
			published: "Veröffentlicht",
			scheduledSlotFromOnly: "Von {date}",
			scheduledSlotUntilOnly: "Bis {date}",
			scheduledChipAriaUpcoming: "Bevorstehende Planung: {dates}",
			scheduledChipAriaActive: "Aktive Planung: {dates}",
			scheduledChipAriaExpired: "Abgelaufene Planung: {dates}",
			invalidScheduleDate: "Das Startdatum muss vor dem Enddatum liegen.",
			refreshList: "Liste aktualisieren",
			lastRefresh: "Letzte Aktualisierung",
			lowData: "Wenig Daten",
			abTestRunning: "A/B-Headline-Test läuft",
			ctrUnavailable: "CTR nicht verfügbar",
			ctrUnavailableHint: "Live-CTR-Daten konnten derzeit nicht geladen werden. Sie werden automatisch aktualisiert."
		}
	}
}, b = [{
	path: `/${n.articleList.path}`,
	meta: { i18RouteTitleKey: n.articleList.path },
	children: [
		{
			path: "",
			name: "article_list_list",
			component: () => import("./article-list-list.view-_m4Qhcoh.js"),
			meta: { requiredRight: "article-lists:navigate" }
		},
		{
			path: "new",
			name: "article_list_new",
			component: () => import("./article-list-edit.view-D7rDN4NP.js"),
			props: (e) => ({
				backRoute: "/article-list",
				tab: e.query.tab
			}),
			meta: { requiredRight: ["article-lists:navigate"] }
		},
		{
			path: ":id",
			name: "article_list_detail",
			component: () => import("./article-list-edit.view-D7rDN4NP.js"),
			props: (e) => ({
				id: e.params.id,
				tab: e.query.tab,
				backRoute: "/article-list"
			}),
			meta: { requiredRight: ["article-lists:navigate"] }
		}
	]
}], x = 600 * 1e3, S = (t, n) => h({
	queryKey: [
		"article-lists",
		t,
		n
	],
	queryFn: () => e(t, n ? { brand: n } : {}),
	staleTime: x
}), C = (e) => h({
	queryKey: ["article-list", e],
	queryFn: () => t(e),
	staleTime: x
}), w = /* @__PURE__ */ s({
	__name: "article-list-selector",
	props: /* @__PURE__ */ c({ brand: {} }, {
		modelValue: {},
		modelModifiers: {}
	}),
	emits: ["update:modelValue"],
	setup(e) {
		let t = e, n = p(e, "modelValue", { set: (e) => e || void 0 }), { t: s } = v(), c = _(), { data: h, isFetching: y } = g(a(() => ({
			...S(void 0, t.brand),
			enabled: !!t.brand
		}))), b = d(null), x = d(null), w = a(() => {
			let e = b.value ?? h.value?.list ?? [], t = x.value;
			return !t || t._id !== n.value || e.some((e) => e._id === t._id) ? e : [...e, t];
		});
		m([() => n.value, () => h.value?.list], async ([e, t]) => {
			if (!e || !t) {
				x.value = null;
				return;
			}
			if (t.some((t) => t._id === e)) {
				x.value = null;
				return;
			}
			let r = await c.fetchQuery(C(e));
			n.value === e && (x.value = r);
		}, { immediate: !0 });
		let T = (e, n) => {
			n(async () => {
				if (!e) {
					b.value = null;
					return;
				}
				let { list: n } = await c.fetchQuery(S(e, t.brand));
				b.value = n;
			});
		};
		return (e, t) => (u(), o(f(i), l({
			modelValue: n.value,
			"onUpdate:modelValue": t[0] ||= (e) => n.value = e,
			"data-qa-channel-block-article-list-selector": "",
			outlined: "",
			dense: "",
			label: f(s)("articleList.articleListLabel"),
			options: w.value,
			"option-value": "_id",
			"option-label": "title",
			"emit-value": "",
			"map-options": "",
			"dropdown-icon": "expand_more",
			clearable: ""
		}, e.$attrs, {
			"use-input": "",
			"input-debounce": f(r),
			loading: f(y),
			onFilter: T
		}), null, 16, [
			"modelValue",
			"label",
			"options",
			"input-debounce",
			"loading"
		]));
	}
}), T = {
	messages: y,
	routes: b,
	contentBlocks: []
};
//#endregion
export { w as ArticleListSelector, T as articleListModule };

//# sourceMappingURL=index.es.js.map